import React from 'react';
import { css } from '@emotion/react';
import t from 'react-translate';

import { warning } from 'styles/global_defaults/colors';

// components
import { LecturePageMode } from 'lecture_pages/components';
import { useLecturePageParams } from 'lecture_pages/hooks/lecture-routing';
import TopPanelActionButton from './top-panel-action-button';
import { config } from '../../../../../config/config.json';

type ExitButtonProps = {
  onClick: () => void;
};

const ExitButton = ({ onClick }: ExitButtonProps) => {
  const params = useLecturePageParams();

  let tooltipText;

  if (params.mode === LecturePageMode.EDIT || params.mode === LecturePageMode.LINKED_EDIT) {
    tooltipText = t.LECTURE_PAGES.ADMIN.COG_OPTIONS.EXIT_EDIT_MODE();
  } else if (params.mode === LecturePageMode.RESTRICTED_EDIT) {
    tooltipText = t.LECTURE_PAGES.ADMIN.COG_OPTIONS.EXIT_ADMIN_MODE();
  }

  return (
    <React.Fragment>
      <TopPanelActionButton
        icon='close'
        tooltipText={tooltipText}
        useDefaultStyle={false}
        className='close-icon p-4 bg-warning'
        tooltipPlacement='bottom-end'
        onClick={onClick}
        ariaLabel={tooltipText}
        dataQa={params.mode === LecturePageMode.RESTRICTED_EDIT
          ? config.pendo.lectureEdit.editMenuTopPanel.exitAdminModeButton
          : config.pendo.lectureEdit.editMenuTopPanel.exitEditModeButton}
      />
    </React.Fragment>
  );
};

export default ExitButton;
